<template>
  <div class="new">
    <div class="new-top">
      <div class="new-top__title">新建服务供应商</div>
      <div class="new-top__tips">*星号必填</div>
    </div>
    <div class="new-module">
      <div class="new-module__left">
        <template v-for="item in supplierInput">
          <template v-if="item.type === 'location'">
            <div class="new-module__list" :key="item.data + 0">
              <div class="new-module__name">
                <span class="new-module__list--star" v-if="item.isRequired">*</span>
                {{ item.name }}:
              </div>
              <div class="new-module__input">
                <el-select size="mini" placeholder="省份"></el-select>
              </div>
            </div>
            <div class="new-module__list" :key="item.data + 1">
              <div class="new-module__name"></div>
              <div class="new-module__input">
                <el-select size="mini" placeholder="城市"></el-select>
              </div>
            </div>
            <div class="new-module__list" :key="item.data + 2">
              <div class="new-module__name"></div>
              <div class="new-module__input">
                <el-select size="mini" placeholder="详细信息"></el-select>
              </div>
            </div>
          </template>
          <template v-else-if="item.type === 'select'">
            <div class="new-module__list" :key="item.data">
              <div class="new-module__name">
                <span class="new-module__list--star" v-if="item.isRequired">*</span>
                {{ item.name }}:
              </div>
              <div class="new-module__input">
                <el-select size="mini" :placeholder="item.pla"></el-select>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="new-module__list" :key="item.data">
              <div class="new-module__name">
                <span class="new-module__list--star" v-if="item.isRequired">*</span>
                {{ item.name }}:
              </div>
              <div class="new-module__input">
                <el-input size="mini" :placeholder="item.pla"></el-input>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="new-module__right">
        <div class="new-module__list" v-for="item in concatInput" :key="item.data">
          <div class="new-module__name">
            <span class="new-module__list--star" v-if="item.isRequired">*</span>
            {{ item.name }}:
          </div>
          <div class="new-module__input">
            <el-input size="mini" :placeholder="item.pla"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="new-module__list new-module__list--remark">
      <div class="new-module__name">备注信息:</div>
      <div class="new-module__input">
        <el-input type="textarea" resize="none" rows="3" size="mini" placeholder="备注信息"></el-input>
      </div>
    </div>
    <div class="new-bottom">
      <div class="new-bottom__btn">保存</div>
    </div>
  </div>
</template>

<script>
import { ServiceSupplierInputBoxNewModule, ServiceSupplier } from './class'
export default {
  name: 'newServiceSupplier',
  data(){
    return{
      serviceSupplier: new ServiceSupplier(),
      supplierInput: ServiceSupplierInputBoxNewModule.NEWSUPPLIERINPUTMODULE(),
      concatInput: ServiceSupplierInputBoxNewModule.NEWCONCATINPUTMODULE(),
    }
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1000px;
  padding: 0 20px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: end;
    padding: 5px 0;
    border-bottom: 1px solid black;
    &__title{
      font-size: 18px;
      font-weight: bold;
      color: black;
    }
    &__tips{
      font-size: 12px;
      font-weight: normal;
      color: #fca605;
    }
  }
  &-module{
    display: flex;
    justify-content: space-between;
    padding: 10px 50px;
    &__list{
      display: flex;
      justify-content: end;
      align-items: center;
      margin: 10px 0;
      ::v-deep{
        .el-input__inner{
          width: 300px;
        }
      }
      &--star{
        color: red;
      }
      &--remark{
        justify-content: start;
        margin-left: 94px;
        margin-top: -10px;
        align-items: start;
        .new-module__name{
          margin-top: 8px;
        }
        ::v-deep{
          .el-textarea__inner{
            width: 765px;
            border-radius: 0;
          }
        }
      }
    }
    &__name{
      margin: 0 10px;
      font-size: 12px;
    }
  }
  &-bottom{
    display: flex;
    justify-content: end;
    align-items: center;
    margin: 20px 50px 0;
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
